import jwt from '@src/auth/jwt/useJwt'

export const fetchAdminTicketsApi = async ({ userId, cursor, limit = 10, status, title }) => {
  const params = { limit }
  if (cursor) params.cursor = cursor
  if (status) params.status = status
  if (title) params.title = title
  try {
    const response = await jwt.get('admin/tickets', {
      params,
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status_ = error?.response?.status
    if (status_ === 403) {
      const err = new Error('FORBIDDEN')
      err.type = 'FORBIDDEN'
      throw err
    }
    const err = new Error(`Error del servidor: ${status_ || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const fetchAdminTicketDetailApi = async ({ userId, ticketId }) => {
  try {
    const response = await jwt.get(`admin/tickets/${ticketId}`, {
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('FORBIDDEN')
      err.type = 'FORBIDDEN'
      throw err
    }
    if (status === 404) {
      const err = new Error('NOT_FOUND')
      err.type = 'NOT_FOUND'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const respondAdminTicketApi = async ({ userId, ticketId, message }) => {
  try {
    const response = await jwt.post(
      `admin/tickets/${ticketId}/respond`,
      { response: message },
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('FORBIDDEN')
      err.type = 'FORBIDDEN'
      throw err
    }
    if (status === 404) {
      const err = new Error('NOT_FOUND')
      err.type = 'NOT_FOUND'
      throw err
    }
    if (status === 409) {
      const err = new Error('TICKET_CLOSED')
      err.type = 'TICKET_CLOSED'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const closeAdminTicketApi = async ({ userId, ticketId }) => {
  try {
    const response = await jwt.post(
      `admin/tickets/${ticketId}/close`,
      {},
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('FORBIDDEN')
      err.type = 'FORBIDDEN'
      throw err
    }
    if (status === 404) {
      const err = new Error('NOT_FOUND')
      err.type = 'NOT_FOUND'
      throw err
    }
    if (status === 409) {
      const err = new Error('TICKET_CLOSED')
      err.type = 'TICKET_CLOSED'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const reopenAdminTicketApi = async ({ userId, ticketId }) => {
  try {
    const response = await jwt.post(
      `admin/tickets/${ticketId}/reopen`,
      {},
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('FORBIDDEN')
      err.type = 'FORBIDDEN'
      throw err
    }
    if (status === 404) {
      const err = new Error('NOT_FOUND')
      err.type = 'NOT_FOUND'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}
